import { PanelSectionRoot } from "./panel-section-root";
import { PanelSectionSeparator } from "./panel-section-separator";
import { PanelSectionHeader } from "./panel-section-header";
import { PanelSectionTitle } from "./panel-section-title";
import { PanelSectionContent } from "./panel-section-content";

export const PanelSection = {
  Root: PanelSectionRoot,
  Separator: PanelSectionSeparator,
  Header: PanelSectionHeader,
  Title: PanelSectionTitle,
  Content: PanelSectionContent,
};
